var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 File Not found")]),_vm._v(" "),_c('p',[_vm._v("お探しのページは見つかりませんでした。")]),_vm._v(" "),_c('p',[_vm._v("一時的にアクセスできない状況にあるか、移動もしくは削除された可能性があります。")]),_vm._v(" "),_c('p',[_vm._v("もう一度URLが正しいかお確かめください。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c9f4bcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = gTTK
// module chunks = 1